/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicUnitPriceRate extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicUnitPriceRate");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicUnitPriceRate.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicUnitPriceRate>): BackgroundJobPayloadForPeriodicUnitPriceRate {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicUnitPriceRate(), model);
        BackgroundJobPayloadForPeriodicUnitPriceRate.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicUnitPriceRate>): BackgroundJobPayloadForPeriodicUnitPriceRate {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicUnitPriceRate.newInstance(<BackgroundJobPayloadForPeriodicUnitPriceRate> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicUnitPriceRate) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicUnitPriceRate.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicUnitPriceRate): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicUnitPriceRate.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
